const headers = {
  Accept: 'application/json',
  'content-type': 'application/json',
}

// Do not specify Content-Type for multipart/form-data requested
const formDataHeaders = {
  Accept: 'application/json',
}

const config = {
  BASE_URL: `${SERVER_BASE_URL}`,
  SERVICE_URL: `${SERVICE_URL}`,
  DELETE: {
    method: 'DELETE',
    headers,
  },
  GET: {
    method: 'GET',
    headers,
  },
  PATCH: {
    method: 'PATCH',
    headers,
  },
  POST: {
    method: 'POST',
    headers,
  },
  PUT: {
    method: 'PUT',
    headers,
  },
  POST_FORM_DATA: {
    method: 'POST',
    headers: formDataHeaders,
  },
}

export default config
